import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules';

export type RemoveStandardAreaInstallationFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: RemoveStandardAreaInstallationFormProps) => {
  const [
    fnRemoveStandardAreaInstallationForm,
    { loading }
  ] = ds.useRemoveStandardAreaInstallation();

  const handleSubmit = async (id: string) => {

    await fnRemoveStandardAreaInstallationForm(id);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      isLoading={loading}
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(props.id);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <></>
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
